class Swiper {
   constructor(container, options = {}) {
      this.container = document.querySelector(container);
      this.wrapper = this.container.querySelector(".swiper-wrapper");
      this.slides = this.container.querySelectorAll(".swiper-slide");
      this.paginationDots = this.container.querySelectorAll(".pagination-dot");
      this.index = 0;
      this.options = Object.assign({ delay: 3000 }, options);
      this.init();
   }

   init() {
      if (this.slides.length > 1) {
         this.startAutoplay();
         this.updatePagination();
         this.addPaginationEvents();
      }
   }

   startAutoplay() {
      this.interval = setInterval(() => this.nextSlide(), this.options.delay);
   }

   nextSlide() {
      this.index = (this.index + 1) % this.slides.length;
      this.updateSlidePosition();
   }

   updateSlidePosition() {
      const offset = -this.index * 100;
      this.wrapper.style.transform = `translateX(${offset}%)`;
      this.updatePagination();
   }

   updatePagination() {
      this.paginationDots.forEach((dot, i) => {
         dot.classList.toggle("active", i === this.index);
      });
   }

   addPaginationEvents() {
      this.paginationDots.forEach((dot, i) => {
         dot.addEventListener("click", () => {
            this.index = i;
            this.updateSlidePosition();
         });
      });
   }
}
